// DataForSEO Location Codes
// Source: https://docs.dataforseo.com/v3/serp/google/locations/

export const DATAFORSEO_LOCATIONS = {
    // Global (no location constraint — worldwide)
    'GLOBAL': { name: '🌍 Global', code: 0 },

    // North America
    'US': { name: '🇺🇸 United States', code: 2840 },
    'CA': { name: '🇨🇦 Canada', code: 2124 },
    'MX': { name: '🇲🇽 Mexico', code: 2484 },

    // Europe
    'GB': { name: '🇬🇧 United Kingdom', code: 2826 },
    'DE': { name: '🇩🇪 Germany', code: 2276 },
    'FR': { name: '🇫🇷 France', code: 2250 },
    'ES': { name: '🇪🇸 Spain', code: 2724 },
    'IT': { name: '🇮🇹 Italy', code: 2380 },
    'NL': { name: '🇳🇱 Netherlands', code: 2528 },
    'BE': { name: '🇧🇪 Belgium', code: 2056 },
    'CH': { name: '🇨🇭 Switzerland', code: 2756 },
    'AT': { name: '🇦🇹 Austria', code: 2040 },
    'SE': { name: '🇸🇪 Sweden', code: 2752 },
    'NO': { name: '🇳🇴 Norway', code: 2578 },
    'DK': { name: '🇩🇰 Denmark', code: 2208 },
    'FI': { name: '🇫🇮 Finland', code: 2246 },
    'PL': { name: '🇵🇱 Poland', code: 2616 },
    'CZ': { name: '🇨🇿 Czech Republic', code: 2203 },
    'PT': { name: '🇵🇹 Portugal', code: 2620 },
    'GR': { name: '🇬🇷 Greece', code: 2300 },
    'IE': { name: '🇮🇪 Ireland', code: 2372 },

    // Asia Pacific
    'IN': { name: '🇮🇳 India', code: 2356 },
    'AU': { name: '🇦🇺 Australia', code: 2036 },
    'NZ': { name: '🇳🇿 New Zealand', code: 2554 },
    'SG': { name: '🇸🇬 Singapore', code: 2702 },
    'MY': { name: '🇲🇾 Malaysia', code: 2458 },
    'TH': { name: '🇹🇭 Thailand', code: 2764 },
    'ID': { name: '🇮🇩 Indonesia', code: 2360 },
    'PH': { name: '🇵🇭 Philippines', code: 2608 },
    'VN': { name: '🇻🇳 Vietnam', code: 2704 },
    'JP': { name: '🇯🇵 Japan', code: 2392 },
    'KR': { name: '🇰🇷 South Korea', code: 2410 },
    'CN': { name: '🇨🇳 China', code: 2156 },
    'HK': { name: '🇭🇰 Hong Kong', code: 2344 },
    'TW': { name: '🇹🇼 Taiwan', code: 2158 },
    'PK': { name: '🇵🇰 Pakistan', code: 2586 },
    'BD': { name: '🇧🇩 Bangladesh', code: 2050 },
    'LK': { name: '🇱🇰 Sri Lanka', code: 2144 },

    // Middle East
    'AE': { name: '🇦🇪 UAE', code: 2784 },
    'SA': { name: '🇸🇦 Saudi Arabia', code: 2682 },
    'IL': { name: '🇮🇱 Israel', code: 2376 },
    'TR': { name: '🇹🇷 Turkey', code: 2792 },
    'EG': { name: '🇪🇬 Egypt', code: 2818 },
    'QA': { name: '🇶🇦 Qatar', code: 2634 },
    'KW': { name: '🇰🇼 Kuwait', code: 2414 },

    // South America
    'BR': { name: '🇧🇷 Brazil', code: 2076 },
    'AR': { name: '🇦🇷 Argentina', code: 2032 },
    'CL': { name: '🇨🇱 Chile', code: 2152 },
    'CO': { name: '🇨🇴 Colombia', code: 2170 },
    'PE': { name: '🇵🇪 Peru', code: 2604 },

    // Africa
    'ZA': { name: '🇿🇦 South Africa', code: 2710 },
    'NG': { name: '🇳🇬 Nigeria', code: 2566 },
    'KE': { name: '🇰🇪 Kenya', code: 2404 },
    'GH': { name: '🇬🇭 Ghana', code: 2288 },
};

// Get all locations as array for dropdown
export const getLocationOptions = () => {
    return Object.entries(DATAFORSEO_LOCATIONS).map(([code, data]) => ({
        value: code,
        label: data.name,
        locationCode: data.code
    }));
};

// Get location code by country code
export const getLocationCode = (countryCode) => {
    return DATAFORSEO_LOCATIONS[countryCode]?.code || 2840;
};

// Get location name by country code
export const getLocationName = (countryCode) => {
    return DATAFORSEO_LOCATIONS[countryCode]?.name || '🇺🇸 United States';
};

// Get country code from location code (reverse lookup)
export const getCountryCodeFromLocationCode = (locationCode) => {
    const parsed = parseInt(locationCode);
    if (!parsed) return 'GLOBAL';
    const entry = Object.entries(DATAFORSEO_LOCATIONS).find(
        ([_, data]) => data.code === parsed
    );
    return entry ? entry[0] : 'GLOBAL'; // Fall back to Global if not found
};

// Popular locations (top 20)
export const POPULAR_LOCATIONS = [
    'US', 'GB', 'CA', 'AU', 'IN',
    'DE', 'FR', 'ES', 'IT', 'BR',
    'MX', 'NL', 'SG', 'AE', 'ZA',
    'JP', 'KR', 'PH', 'MY', 'TH'
];
